export const posthogConfig = {
  url: window["env"]["posthogUrl"] || "",
  key: window["env"]["posthogKey"] || "",
};
